

import { useEffect, useRef, useState } from "react";
import { ActionMenuItem, BaseActions } from "../../components/action-menu/ActionMenuItem";
import { ContentView } from "../../components/content-view/ContentView";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { IOrganization } from "../../services/organization-data-service/Models";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { useGroup } from "../../queries/groups/UseGroup";
import ScheduledReportsList, { ScheduledReportsListType } from "../../components/scheduled-reports-list/ScheduledReportsList";
import { ScheduledReportsActionEnum, actionItems } from "../../components/scheduled-reports-list/ScheduledReportsListUtils";
import { useOrganizations } from "../../queries/organizations/UseOrganizations";

export default function ScheduledReportsAdminView() {
    
    const [userState] = useUserContext();
    const routeContext = useRouteContext();
    const [viewOptionState, setViewOptionState] = useState(ViewOptionStateEnum.Default);
    const [organizationID, setOrganizationID] = useState<number>();

    let reportsListRef = useRef<ScheduledReportsListType>(undefined);

    const {data: group } = useQueryNotifications(useGroup)({
        customerID: userState.customer?.id as number,
        groupID: routeContext.groupID as number
    });

    const {data: organizations} = useQueryNotifications(useOrganizations)({
    });

    const organization = organizations?.find(o => o.id === organizationID);


    function onExecuteAction(menuItem: ActionMenuItem) {

        const action = menuItem.action as ScheduledReportsActionEnum | BaseActions;

        reportsListRef.current?.executeAction(action);
    }

    function onOrganizationChanged(item: IOrganization) {
        setOrganizationID(item.id);
    }


    useEffect(() => {
        if (group && organizationID === undefined) {
            setOrganizationID(group.organizationID as number);
        }
    }, [
        group,
        organizationID,
        setOrganizationID
    ]);

    return (
        <ContentView>
            <ContextualAppBar 
                hideBreadcrumb={true}
                actions={actionItems} 
                viewOptionState={viewOptionState}
                onExecuteAction={onExecuteAction} 
                showOrganizationPicker={true}
                onOrganizationSelected={onOrganizationChanged}
                organizationID={organizationID}
            />

                {
                    organizationID && 

                    <ScheduledReportsList 
                        ref={reportsListRef}
                        groupID={organization?.peerGroupID as number}
                        organizationID={organizationID} 
                        setViewOptionState={setViewOptionState}
                        myReports={false}
                    />
                }


        </ContentView>
    );
  }
